import { Card, Space } from 'antd';
import { useIntl } from 'react-intl';

import { isUserAuthorized } from 'utils/helpers';
import { ACL_MATRIX } from 'common/permissions';

import BRButton from 'components/BRButton/BRButton';
import LoadingWrapper from 'components/LoadingWrapper/LoadingWrapper';

import { ReactComponent as Download } from 'assets/bosta-icons/Download.svg';

import './StatCard.less';

const StatCard = ({
  title,
  titleIcon,
  children,
  extraTitleContent,
  className = '',
  showExportButton = false,
  handleExportOnClick,
  loading = false
}) => {
  const intl = useIntl();

  return (
    <LoadingWrapper loading={loading}>
      <Card
        className={`br-business-analytics-card ${className}`}
        title={
          <Space>
            {titleIcon}
            <span className="heading">{title}</span>
            {extraTitleContent}
          </Space>
        }
        extra={
          showExportButton &&
          isUserAuthorized([], [ACL_MATRIX.BUSINESS_ANALYTICS_EXPORT]) && (
            <BRButton
              type={'basic'}
              onClick={handleExportOnClick}
              label={intl.formatMessage({ id: 'common.export' })}
              prefixIcon={<Download />}
            />
          )
        }
        bordered={true}
      >
        {children}
      </Card>
    </LoadingWrapper>
  );
};

export default StatCard;
